<template>
  <div>
    <v-dialog v-model="model" scrollable persistent max-width="800px">
      <material-card
        :title="isNew ? $t('components.add_credit_dialog.add_credit') : $t('components.add_credit_dialog.edit_credit')"
        :color="$vuetify.theme.themes.light.success"
        :icon="isNew ? 'add' : 'edit'"
      >
        <v-card-text>
          <v-alert v-if="creditError" dense type="error" dismissible>
            {{ $t(creditError) }}
          </v-alert>
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-row justify-center>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4" v-if="isNew">
                  <no-autocomplete-textfield
                    :label="$t('headers.t4a.Year')"
                    v-model="item.Year"
                    :disabled="!isNew"
                    :rules="[
                      $rules.required,
                      $rules.dynamic.length(4),
                      rules.coverageEffectiveYear,
                    ]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <currency-textfield
                    v-model="item.Amount"
                    :label="$t('globals.amount')"
                    class="required"
                    :rules="[$rules.requiredNum, rules.totalAmountNotNegative(item)]"
                  />
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <pbas-date-picker
                    :label="$t('components.inmemorydependants.effective_date')"
                    :value="item.EffectiveDate"
                    @update-date="item.EffectiveDate = $event"
                    :rules="[$rules.required, rules.coverageEffectiveDate]"
                    class="required"
                    :allowedDates="coverageAllowedDates"
                  ></pbas-date-picker>
                </div>
                <div class="col-12">
                  <v-textarea
                    :label="$t('globals.reason')"
                    clearable
                    auto-grow
                    rows="1"
                    counter
                    v-model="item.Reason"
                    class="required"
                    :rules="[$rules.required]"
                  ></v-textarea>
                </div>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text @click="$emit('close')">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            :loading="saving"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue";
export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    CurrencyTextfield,
  },
  props: ["memberIdentity", "model", "credit", "isNew", "credits"],
  data() {
    return {
      valid: true,
      error: null,
      creditError: null,
      saving: false,
      item: {},
      rules: {
        coverageEffectiveDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [
              this.formatValidationDate(d),
            ]);
          }
          if (this.item.Year !== null && this.item.Year !== undefined) {
            const n = Date.parse(`${this.item.Year}-01-01`);
            const d = new Date(n);
            const val = new Date(Date.parse(v));
            return (
              val >= d ||
              this.$t("validation.date_{0}", [this.formatValidationDate(d)])
            );
          }
          if (
            this.memberIdentity === null ||
            this.memberIdentity === undefined ||
            this.memberIdentity.PlanEntryDate === null ||
            this.memberIdentity.PlanEntryDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.memberIdentity.PlanEntryDate);
          const d = new Date(n);
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [this.formatValidationDate(d)])
          );
        },
        coverageEffectiveYear: (v) => {
          if (v === undefined || v === null) {
            return true;
          }
          if (
            this.memberIdentity === null ||
            this.memberIdentity === undefined ||
            this.memberIdentity.PlanEntryDate === null ||
            this.memberIdentity.PlanEntryDate === undefined
          ) {
            return true;
          }
          const planEntryYear = new Date(
            Date.parse(this.memberIdentity.PlanEntryDate)
          ).getFullYear();
          return (
            v >= planEntryYear ||
            this.$t("validation.year_equal_to_or_greater_than_{0}", [
              planEntryYear,
            ])
          );
        },
        totalAmountNotNegative: (v) => {
          if (v === undefined || v === null) {
            return true;
          }
          return (
            this.calculatedTotal >= 0 ||
            this.$t("validation.amount_not_less_than_{0}", [(this.credit.Amount - this.credit.ParentAmount).toFixed(2)])
          );

        },
        // selectedYear: (v) => {
        //   if (this.item.Year === undefined || this.item.Year === null) {
        //     return true;
        //   }
        //   console.log(v);
        //   const effectiveDateYear = new Date(Date.parse(v)).getFullYear();
        //   console.log(this.item.Year, effectiveDateYear);
        //   return effectiveDateYear.toString() === this.item.Year.toString() || this.$t("validation.year_equal_to_{0}", [this.item.Year])
        // }
      },
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    calculatedTotal() {
      // calculate the total of the credits for the year excluding the current credit
      if (this.item && this.item.Year) {
        let total = 0;
        Object.keys(this.credits).forEach((key) => {
          if (key !== this.item.Id) {
            if (
            this.credits[key].Type === "Forfeit" ||
            this.credits[key].Type === "Deduction" ||
            this.credits[key].Type === "Reserved"
            ) {
              total -= this.credits[key].Amount;
            } else {
              total += this.credits[key].Amount;
            }
            console.log("total", total, this.credits[key].Amount);
          }
        });
        total += parseFloat(this.item.Amount);
        // return number to 2 decimal places
        return Math.round(total * 100) / 100;
      }
      return 0;

    },
  },
  mounted() {
    console.log("mounted AddCreditDialog");
    // if (this.model) {
    //   console.log("got model", this.model);
    //   if (this.credit) {
    //     console.log("got credit", this.credit);
    //     this.item = JSON.parse(JSON.stringify(this.credit));
    //   } else {
    //     this.item = {};
    //   }
    // }
  },
  methods: {
    ...mapActions("claims", ["addMemberCredit", "updateMemberCredit"]),
    async save() {
      this.error = null;
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.item));
        item.Amount = parseFloat(item.Amount);
        delete item.ParentAmount;
        if (this.isNew) {
          await this.addMemberCredit({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentity.Id,
          payload: item,
        });
        } else {
          await this.updateMemberCredit({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.memberIdentity.Id,
            creditId: this.item.Id,
            payload: {
              Amount: item.Amount,
              EffectiveDate: item.EffectiveDate,
              Reason: item.Reason,
            },
          });
        }
        this.$emit("save");
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
      }
    },
    coverageAllowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      if (this.item && this.item.Year !== null && this.item.Year !== undefined) {
        const d2 = new Date(Date.parse(`${this.item.Year}-01-01`));
        return d >= d2;
      }
      const n2 = Date.parse(this.memberIdentity.PlanEntryDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.item = {};
        }
      },
    },
    credit: {
      handler(v) {
        if (v) {
          this.item = JSON.parse(JSON.stringify(v));
          if (v.Year) {
            this.item.Year = v.Year.toString();
          } else {
            this.item = {};
          }
        } else {
          this.item = {};
        }
      },
      immediate: true,
      deep: true,
    },
    calculatedTotal: {
      handler(v) {
        if (v < 0) {
          this.creditError = "components.add_credit_dialog.negative_credit_error";
        } else {
          this.creditError = null;
        }
      },
      immediate: true,
    },
  },
};
</script>
